class PolicyFinancialInstitution {
    constructor(id, value) {
        this.id = id
        this.value = value
    }

    static fromJson({ id, name }) {
        return new PolicyFinancialInstitution(id, name)
    }
}

export default PolicyFinancialInstitution
